import Axios from "axios";
import { apiUrl } from "../../constants";

const productFilesBaseUrl = `${apiUrl}/productFiles`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const productFilesApi = {
  getProductFiles: (productId: number) => {
    return Axios.get(`${productFilesBaseUrl}/product/${productId}`, config);
  },

  uploadFile: (productId: number, file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    return Axios.post(`${productFilesBaseUrl}/upload/${productId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  downloadFile: (productFileId: number) => {
    return Axios.get(`${productFilesBaseUrl}/download/${productFileId}`, {
      responseType: "blob"
    });
  },

  deleteFile: (productFileId: number) => {
    return Axios.delete(`${productFilesBaseUrl}/${productFileId}`, config);
  },

  updateFileDescription: (productFileId: number, description: string) => {
    return Axios.put(`${productFilesBaseUrl}/${productFileId}`, { description }, config);
  }
};
